import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GenericFormScene } from 'shared-ui/lib/components/generic-form-scene/GenericFormScene';
import { parseGraphqlErrors } from 'shared-ui/lib/utils/get-gql-error';
import { routesConfig } from '../../config/routes.config';
import {
  vehicleCreateForm,
  VehicleCreateFormBody,
} from '../../form/vehicle-create/vehicleCreate.form';
import {
  SidebarVehicleCountDocument,
  useCreateVehicleMutation,
} from '../../generated/graphql';
import { useUploadFile } from '../../hooks/use-upload-file';
import { GraphQLError } from 'graphql';

export const VehicleCreateScene = (): JSX.Element => {
  const { t } = useTranslation('VehicleCreateScene');
  const navigate = useNavigate();
  const [createVehicle, { loading }] = useCreateVehicleMutation({
    refetchQueries: [{ query: SidebarVehicleCountDocument }],
  });
  const { uploadFile, isImageLoading } = useUploadFile({
    type: 'vehicle-image',
  });

  const handleSubmit = async ({ photo, ...body }: VehicleCreateFormBody) => {
    const { data, errors } = await createVehicle({ variables: { body } });
    if (!data) throw new Error(parseGraphqlErrors(errors as GraphQLError[]));
    await uploadFile(photo, data.createVehicle.id);
    navigate(routesConfig.VEHICLES.CHOOSE_PAYMENT.replace(':id', data.createVehicle.id));
  };

  return (
    <GenericFormScene
      type="create"
      title={t('addVehicle')}
      onSubmit={handleSubmit}
      onSubmitValidationFailed={() => toast.error(t('notSavedCheckFields'))}
      form={vehicleCreateForm}
      isSubmitLoading={loading || isImageLoading}
      backLink={routesConfig.DASHBOARD}
    />
  );
};
